//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Icons used to distinguish streets
//
//  Copyright:    © 2021 - 2023 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//region Version 1.0.0.0
//    001   23.07.21 Sean Flook         WI39??? Initial Revision.
//    002   06.10.23 Sean Flook                 Use colour variables.
//endregion Version 1.0.0.0
//region Version 1.0.0.0
//    003   201.11.24 Sean Flook     IMANN-1010 No longer need to take 10 from the type.
//endregion Version 1.0.0.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

//region imports

import React from "react";
import { SvgIcon } from "@mui/material";
import { adsWhite } from "./ADSColours";

//endregion imports

/**
 * Method to get the street icon.
 *
 * @param {number} type The type of street.
 * @param {object} nameClass The styling to use on the icon.
 * @param {object|null} props The passed in properties.
 * @returns {JSX.Element} The required street icon.
 */
export default function GetStreetIcon(type, nameClass, props) {
  if (!type) return null;

  if (nameClass) {
    return (
      <SvgIcon
        sx={nameClass}
        {...props}
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          strokeLinejoin: "round",
          strokeMiterlimit: 2,
        }}
      >
        <path
          id="path2"
          d="M21,21L3,21L7.5,3L16.5,3L21,21ZM13,14L11,14L11,18L13,18L13,14ZM13,9L11,9L11,12L13,12L13,9ZM13,5L11,5L11,7L13,7L13,5Z"
        />
        <g id="g8" transform={"matrix(0.51468531,0,0,0.51468531,12.425174,10.620979)"}>
          <path
            id="path6"
            d="M 12,2 C 6.47,2 2,6.47 2,12 2,17.53 6.47,22 12,22 17.53,22 22,17.53 22,12 22,6.47 17.53,2 12,2 Z m 0,18 C 7.58,20 4,16.42 4,12 4,7.58 7.58,4 12,4 c 4.42,0 8,3.58 8,8 0,4.42 -3.58,8 -8,8 z"
          />
        </g>
        <path
          id="path828"
          d="m 18.075524,21.930691 c -0.03846,-0.0066 -0.164335,-0.02535 -0.27972,-0.04168 -0.637112,-0.09018 -1.403351,-0.381824 -1.988808,-0.756983 L 15.594412,20.995804 H 9.2965066 c -3.4638479,0 -6.2975256,-0.0094 -6.2970616,-0.02098 4.641e-4,-0.01154 1.0113902,-4.061538 2.2465026,-9 l 2.2456591,-8.9790208 4.5052433,-0.00708 4.505244,-0.00708 1.08289,4.3317137 1.08289,4.3317131 0.312217,0.01615 c 1.216741,0.06293 2.467731,0.65226 3.347898,1.577165 0.979211,1.028983 1.470236,2.331085 1.41693,3.757415 -0.03032,0.811239 -0.214895,1.510016 -0.582762,2.206246 -0.741163,1.402737 -2.096345,2.393121 -3.660059,2.674819 -0.252723,0.04553 -1.254475,0.08332 -1.426574,0.05382 z m 2.990517,-1.84848 c 0.248632,-0.185464 0.604856,-0.537671 0.795605,-0.786633 1.04287,-1.361132 1.121075,-3.279312 0.19241,-4.719354 -0.604241,-0.936972 -1.575824,-1.594619 -2.668858,-1.806503 -0.270606,-0.05246 -0.442541,-0.0678 -0.442541,-0.03949 0,0.01336 1.789452,7.182108 1.848532,7.405428 0.01526,0.05769 0.03559,0.104895 0.04516,0.104895 0.0096,0 0.112937,-0.07126 0.229691,-0.158348 z m -8.081426,-4.079414 v -2 h -0.993007 -0.993007 v 1.981352 c 0,1.089744 0.0084,1.989744 0.01865,2 0.01026,0.01026 0.457109,0.01865 0.993007,0.01865 h 0.974358 z m 0,-5.510847 V 8.9950884 l -0.986014,0.00735 -0.986014,0.00735 -0.0072,1.4895106 -0.0072,1.48951 h 0.993252 0.993252 z m 0,-4.5034966 V 4.9950885 l -0.986014,0.00735 -0.986014,0.00735 -0.0074,0.986014 -0.0074,0.986014 h 0.993365 0.993364 z"
        />
        <path
          id="path830"
          d="m 20.791189,20.107692 c -0.07136,-0.269745 -1.817138,-7.272512 -1.825281,-7.321678 -0.0083,-0.04989 0.0044,-0.05514 0.116609,-0.0485 0.530081,0.03135 1.257543,0.301083 1.81746,0.67389 0.298115,0.198493 0.763581,0.64386 0.994541,0.951595 0.331125,0.441199 0.592748,1.026973 0.717532,1.606556 0.09011,0.418547 0.08962,1.223138 -0.001,1.641634 -0.120577,0.55677 -0.324171,1.044624 -0.624531,1.496503 -0.231335,0.348034 -1.011884,1.104895 -1.139476,1.104895 -0.01545,0 -0.04058,-0.0472 -0.05584,-0.104895 z"
        />
        <path
          id="path832"
          d="M 18.08951,21.955447 C 17.267378,21.84772 16.53223,21.593626 15.847238,21.180436 l -0.256259,-0.154577 -6.2752098,-0.008 c -3.4513653,-0.0044 -6.2894269,-0.01728 -6.3068034,-0.02858 -0.022094,-0.01437 0.6435019,-2.720887 2.2136978,-9.001577 1.2349101,-4.9395663 2.2509792,-8.9867176 2.2579308,-8.9936693 0.00695,-0.00695 2.0435541,-0.015683 4.5257826,-0.019402 l 4.513144,-0.00676 1.080392,4.3215275 1.080393,4.3215278 0.356632,0.03374 c 0.638997,0.06045 1.106685,0.178325 1.646234,0.414912 1.348229,0.591184 2.415443,1.784259 2.857369,3.194352 0.306193,0.976995 0.300776,2.14428 -0.01456,3.137148 -0.191223,0.602091 -0.60038,1.31869 -1.043633,1.827824 -0.557834,0.640745 -1.375636,1.187015 -2.205345,1.473111 -0.500043,0.172421 -0.784889,0.223276 -1.424496,0.254318 -0.577342,0.02802 -0.615532,0.02848 -0.762998,0.0092 z m -5.132867,-5.95265 v -1.972028 h -0.965035 -0.965035 v 1.972028 1.972028 h 0.965035 0.965035 z m 0,-5.510489 V 9.0237762 h -0.965035 -0.965035 v 1.4685318 1.468531 h 0.965035 0.965035 z m 0,-4.5034968 v -0.965035 h -0.965035 -0.965035 v 0.965035 0.965035 h 0.965035 0.965035 z"
        />
        <text
          id="text836"
          y="20.727282"
          x="15.921395"
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: "bold",
            fontStretch: "normal",
            fontSize: "11.12072182px",
            lineHeight: 1.25,
            fontFamily: "Arial",
            letterSpacing: "0px",
            wordSpacing: "0px",
            opacity: 1,
            fill: adsWhite,
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.52128381,
          }}
        >
          <tspan style={{ fill: adsWhite, strokeWidth: 0.52128381 }} y="20.727282" x="15.921395" id="tspan834">
            {`${type}`}
          </tspan>
        </text>
      </SvgIcon>
    );
  } else {
    return (
      <SvgIcon
        {...props}
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          strokeLinejoin: "round",
          strokeMiterlimit: 2,
        }}
      >
        <path
          id="path2"
          d="M21,21L3,21L7.5,3L16.5,3L21,21ZM13,14L11,14L11,18L13,18L13,14ZM13,9L11,9L11,12L13,12L13,9ZM13,5L11,5L11,7L13,7L13,5Z"
        />
        <g id="g8" transform={"matrix(0.51468531,0,0,0.51468531,12.425174,10.620979)"}>
          <path
            id="path6"
            d="M 12,2 C 6.47,2 2,6.47 2,12 2,17.53 6.47,22 12,22 17.53,22 22,17.53 22,12 22,6.47 17.53,2 12,2 Z m 0,18 C 7.58,20 4,16.42 4,12 4,7.58 7.58,4 12,4 c 4.42,0 8,3.58 8,8 0,4.42 -3.58,8 -8,8 z"
          />
        </g>
        <path
          id="path828"
          d="m 18.075524,21.930691 c -0.03846,-0.0066 -0.164335,-0.02535 -0.27972,-0.04168 -0.637112,-0.09018 -1.403351,-0.381824 -1.988808,-0.756983 L 15.594412,20.995804 H 9.2965066 c -3.4638479,0 -6.2975256,-0.0094 -6.2970616,-0.02098 4.641e-4,-0.01154 1.0113902,-4.061538 2.2465026,-9 l 2.2456591,-8.9790208 4.5052433,-0.00708 4.505244,-0.00708 1.08289,4.3317137 1.08289,4.3317131 0.312217,0.01615 c 1.216741,0.06293 2.467731,0.65226 3.347898,1.577165 0.979211,1.028983 1.470236,2.331085 1.41693,3.757415 -0.03032,0.811239 -0.214895,1.510016 -0.582762,2.206246 -0.741163,1.402737 -2.096345,2.393121 -3.660059,2.674819 -0.252723,0.04553 -1.254475,0.08332 -1.426574,0.05382 z m 2.990517,-1.84848 c 0.248632,-0.185464 0.604856,-0.537671 0.795605,-0.786633 1.04287,-1.361132 1.121075,-3.279312 0.19241,-4.719354 -0.604241,-0.936972 -1.575824,-1.594619 -2.668858,-1.806503 -0.270606,-0.05246 -0.442541,-0.0678 -0.442541,-0.03949 0,0.01336 1.789452,7.182108 1.848532,7.405428 0.01526,0.05769 0.03559,0.104895 0.04516,0.104895 0.0096,0 0.112937,-0.07126 0.229691,-0.158348 z m -8.081426,-4.079414 v -2 h -0.993007 -0.993007 v 1.981352 c 0,1.089744 0.0084,1.989744 0.01865,2 0.01026,0.01026 0.457109,0.01865 0.993007,0.01865 h 0.974358 z m 0,-5.510847 V 8.9950884 l -0.986014,0.00735 -0.986014,0.00735 -0.0072,1.4895106 -0.0072,1.48951 h 0.993252 0.993252 z m 0,-4.5034966 V 4.9950885 l -0.986014,0.00735 -0.986014,0.00735 -0.0074,0.986014 -0.0074,0.986014 h 0.993365 0.993364 z"
        />
        <path
          id="path830"
          d="m 20.791189,20.107692 c -0.07136,-0.269745 -1.817138,-7.272512 -1.825281,-7.321678 -0.0083,-0.04989 0.0044,-0.05514 0.116609,-0.0485 0.530081,0.03135 1.257543,0.301083 1.81746,0.67389 0.298115,0.198493 0.763581,0.64386 0.994541,0.951595 0.331125,0.441199 0.592748,1.026973 0.717532,1.606556 0.09011,0.418547 0.08962,1.223138 -0.001,1.641634 -0.120577,0.55677 -0.324171,1.044624 -0.624531,1.496503 -0.231335,0.348034 -1.011884,1.104895 -1.139476,1.104895 -0.01545,0 -0.04058,-0.0472 -0.05584,-0.104895 z"
        />
        <path
          id="path832"
          d="M 18.08951,21.955447 C 17.267378,21.84772 16.53223,21.593626 15.847238,21.180436 l -0.256259,-0.154577 -6.2752098,-0.008 c -3.4513653,-0.0044 -6.2894269,-0.01728 -6.3068034,-0.02858 -0.022094,-0.01437 0.6435019,-2.720887 2.2136978,-9.001577 1.2349101,-4.9395663 2.2509792,-8.9867176 2.2579308,-8.9936693 0.00695,-0.00695 2.0435541,-0.015683 4.5257826,-0.019402 l 4.513144,-0.00676 1.080392,4.3215275 1.080393,4.3215278 0.356632,0.03374 c 0.638997,0.06045 1.106685,0.178325 1.646234,0.414912 1.348229,0.591184 2.415443,1.784259 2.857369,3.194352 0.306193,0.976995 0.300776,2.14428 -0.01456,3.137148 -0.191223,0.602091 -0.60038,1.31869 -1.043633,1.827824 -0.557834,0.640745 -1.375636,1.187015 -2.205345,1.473111 -0.500043,0.172421 -0.784889,0.223276 -1.424496,0.254318 -0.577342,0.02802 -0.615532,0.02848 -0.762998,0.0092 z m -5.132867,-5.95265 v -1.972028 h -0.965035 -0.965035 v 1.972028 1.972028 h 0.965035 0.965035 z m 0,-5.510489 V 9.0237762 h -0.965035 -0.965035 v 1.4685318 1.468531 h 0.965035 0.965035 z m 0,-4.5034968 v -0.965035 h -0.965035 -0.965035 v 0.965035 0.965035 h 0.965035 0.965035 z"
        />
        <text
          id="text836"
          y="20.727282"
          x="15.921395"
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: "bold",
            fontStretch: "normal",
            fontSize: "11.12072182px",
            lineHeight: 1.25,
            fontFamily: "Arial",
            letterSpacing: "0px",
            wordSpacing: "0px",
            opacity: 1,
            fill: adsWhite,
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.52128381,
          }}
        >
          <tspan style={{ fill: adsWhite, strokeWidth: 0.52128381 }} y="20.727282" x="15.921395" id="tspan834">
            {`${type}`}
          </tspan>
        </text>
      </SvgIcon>
    );
  }
}
